import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  deleteImageFromGoalRequest: ["id", "imageId"],
  deleteImageFromGoalSuccess: ["goal"],
  deleteImageFromGoalFailure: null,
});

export const DeleteImageFromGoalTypes = Types;
export const DeleteImageFromGoalActions = Creators;
export default Creators;

export const INITIAL_STATE = Immutable({
  id: null,
  imageId: null,
  fetching: null,
  success: null,
  error: null,
  goal: null,
});

export const DeleteImageFromGoalSelectors = {
  getData: (state: any) => state.deleteImageFromGoal.data,
  isFetching: (state: any) => state.deleteImageFromGoal.fetching,
  isSuccess: (state: any) => state.deleteImageFromGoal.success,
  hasError: (state: any) => state.deleteImageFromGoal.error,
};

export const request = (state: any, { id, imageId }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    id: id,
    imageId: imageId,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { goal } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    goal: goal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DELETE_IMAGE_FROM_GOAL_REQUEST]: request,
  [Types.DELETE_IMAGE_FROM_GOAL_SUCCESS]: success,
  [Types.DELETE_IMAGE_FROM_GOAL_FAILURE]: failure,
});
